import { orderPromoDetails } from '../../utils/orderPromoDetails';
import React, { useEffect, useRef, useState } from 'react';
import { changeOrderPromo } from '../../api/promoCodesApi';
import { getPromoErrorText } from '../../utils/promoErrors';
import PromoCodeLabel from './PromoCodeLabel';
import { formatPrice } from '../../utils/utils';
import '../../styles/promo-codes.css';

export default function AdminOrderPromo({ order, onChanged, inputId = 'admin-order-promo' }) {
  const [text, setText] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const request = useRef(0);
  const saving = useRef(false);
  useEffect(() => {
    setText(''); setExpanded(false); setError(''); setBusy(false); saving.current = false;
    return () => { request.current += 1; saving.current = false; };
  }, [order.orderId]);
  const status = order.orderStatus?.databaseValue ?? order.orderStatus;
  const locked = order.promoLocked || ['SENT', 'CANCELLED', 'RETURNED'].includes(status);
  const save = async code => {
    if (saving.current || locked) return;
    saving.current = true;
    const sequence = request.current;
    setBusy(true); setError('');
    try {
      await changeOrderPromo(order.orderId, code.trim().toUpperCase());
      if (sequence !== request.current) return;
      setText(''); setExpanded(false); await onChanged();
    } catch (reason) {
      if (sequence === request.current) setError(getPromoErrorText(reason));
    } finally {
      if (sequence === request.current) { setBusy(false); saving.current = false; }
    }
  };
  const promo = orderPromoDetails(order);
  const totalPrice = order.price ?? order.totalPrice ?? 0;
  const finalTotal = order.finalTotal ?? order.discountedPrice ?? totalPrice;
  return <div className='admin-order-promo-totals'>
    <div className='admin-order-totals-line'>
      {promo && <div className='admin-order-promo-inline'>
        <PromoCodeLabel promo={promo} />
        <strong>−{formatPrice(promo.promoDiscountAmount ?? 0)} грн</strong>
        {!locked && <button type='button' className='admin-order-promo-remove' aria-label='Видалити промокод' title='Видалити промокод'
          disabled={busy} onClick={() => save('')}><i className='bi bi-x-lg' aria-hidden='true' /></button>}
      </div>}
      {!locked && !order.promoCode && <div className='admin-order-promo-entry'>
        {expanded ? <>
          <label htmlFor={inputId} className='sr-only'>Промокод</label>
          <div className='checkout-promo-entry'>
            <input id={inputId} className='form-control form-control-sm' autoFocus
              placeholder='Введіть промокод' value={text} maxLength={64} autoComplete='off' autoCapitalize='none' disabled={busy}
              onChange={event => setText(event.target.value)}
              onKeyDown={event => { if (event.key === 'Enter') { event.preventDefault(); if (text.trim() && !busy) save(text); } }} />
            <button type='button' className='btn btn-sm btn-dark' disabled={busy || !text.trim()} onClick={() => save(text)}>Застосувати</button>
          </div>
        </> : <button type='button' className='btn btn-sm promo-code-toggle p-0' onClick={() => setExpanded(true)}>
          <i className='bi bi-ticket-perforated mr-1' aria-hidden='true' />Додати промокод
        </button>}
      </div>}
      <div className='admin-order-total'>
        <span>Загальна сума:</span>
        {totalPrice > finalTotal &&
          <del>{formatPrice(totalPrice)} грн</del>}
        <strong>{formatPrice(finalTotal)} грн</strong>
      </div>
    </div>
    {busy && <div className='small text-muted mt-2' role='status'>Оновлюємо знижку…</div>}
    {error && <div className='promo-code-error text-danger mt-2' role='alert'>{error}</div>}
  </div>;
}
